var render = function render(){var _vm=this,_c=_vm._self._c;return _c('connection-success',{attrs:{"buttons":_vm.buttons,"is-new-brand":""},scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v("\n    "+_vm._s(_vm.title)+"\n  ")]},proxy:true},{key:"subtitle",fn:function(){return [_vm._v("\n    "+_vm._s(_vm.subtitle)+"\n  ")]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }